import styled from 'styled-components';
import { colours } from 'themes/default';

import { extendedServiceStopStatuses } from 'types/timetableServices';

const statusColours = {
  [extendedServiceStopStatuses.CANCELLED]: colours.Messaging.ErrorRed,
  [extendedServiceStopStatuses.EXPECTED]: colours.Messaging.WarningOrange,
  [extendedServiceStopStatuses.ARRIVED_ON_TIME]: colours.Messaging.SuccessGreen,
  [extendedServiceStopStatuses.ARRIVED_EARLY]: colours.Messaging.SuccessGreen,
  [extendedServiceStopStatuses.ARRIVED_LATE]: colours.Messaging.ErrorRed,
  [extendedServiceStopStatuses.DEPARTED_ON_TIME]: colours.Messaging.SuccessGreen,
  [extendedServiceStopStatuses.DEPARTED_EARLY]: colours.Messaging.SuccessGreen,
  [extendedServiceStopStatuses.DEPARTED_LATE]: colours.Messaging.ErrorRed
};

export const TimetableStatusSpan = styled.span`
  color: ${({ statusLevel }) => statusColours[statusLevel] || 'inherit'};
  display: block;
`;

export const TimetableStatusLoading = styled.span`
  display: block;
  opacity: 0.25;

  &::before {
    content: '...';
  }
`;

export const TimetableStatusEmpty = styled.span`
  display: block;

  &::before {
    content: '\\00a0';
  }
`;
